export default __webpack_public_path__ + "static/media/slider_image_02-lg@2x.34654caa.webp";